import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import LogoIcon from "src/assets/LogoIcon.svg";

type Props = {
  /**
   * Flow mode: hides the Profile link so students can't navigate away mid-flow,
   * and intercepts logo clicks with a confirmation dialog warning that progress
   * won't be saved.
   */
  disableNavigation?: boolean;
};

const MenuV2 = ({ disableNavigation }: Props) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();
  const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState(false);

  const handleLogoClick = () => {
    if (disableNavigation) {
      setIsLeaveDialogOpen(true);
    } else {
      navigate("/");
    }
  };

  const handleCancelLeave = () => {
    setIsLeaveDialogOpen(false);
  };

  const handleConfirmLeave = () => {
    setIsLeaveDialogOpen(false);
    navigate("/");
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          backgroundColor: "transparent",
          padding: theme.spacing(2),
          paddingX: theme.spacing(3),
          borderBottom: 1,
          borderColor: theme.palette.grey[200],
        }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          onClick={handleLogoClick}
          sx={{
            cursor: "pointer",
          }}
        >
          <img
            src={LogoIcon}
            alt="Emerge Career"
            style={{ height: 32, width: "auto" }}
          />
        </Box>
        {!disableNavigation && (
          <Link
            to="/profile"
            style={{
              textDecoration: "none",
              color: theme.palette.text.primary,
            }}
          >
            <Typography
              variant="body2"
              fontWeight={700}
              sx={{
                fontFamily: "'PP Fragment', sans-serif",
                textTransform: "uppercase",
                "&:hover": {
                  color: theme.palette.primary.main,
                },
              }}
            >
              Profile
            </Typography>
          </Link>
        )}
      </Stack>
      <Dialog open={isLeaveDialogOpen} onClose={handleCancelLeave}>
        <DialogTitle>{t("Leave quiz?")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("Your progress on this quiz won't be saved.")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelLeave}>{t("Cancel")}</Button>
          <Button onClick={handleConfirmLeave} color="error">
            {t("Leave")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MenuV2;
